<template>
	<div
		class="related-products-item"
		:class="{ 'commerce-home' : commerceHome, 'catalog-product-item' : catalog }"
		:style="`background-color: ${theme.base};`"
	>
		<div :class="{ 'commerce-home-container' : commerceHome, 'catalog-product-container' : catalog }">
			<div class="related-products-item-image">
				<div class="tooltip" v-if="product.urlImage">
					<button
						class="tooltip-activator"
						type="button"
						@click="$emit('open-gallery', product)"
					>
						<v-icon color="white">zoom_in</v-icon>
					</button>
					<span class="tooltip-text" :style="`color: ${theme.base};`">
						Ver imágenes del producto
					</span>
				</div>
				<img
					v-if="product.urlImage"
					:src="product.urlImage"
					:alt="product.name"
				/>
			</div>
			<div class="related-products-item-info">
				<div :class="{ 'catalog-related-products-item-info' : catalog }">
					<h4 class="related-products-item-name" :title="product.name">
						{{ product.name }}
					</h4>
					<h4 class="related-products-item-name">
						{{ product.unitName }}
					</h4>
					<span v-if="!catalog" class="related-products-item-brand">
						{{ product.brandName }}
					</span>
				</div>
				<p class="p-bold desktop" :id="`desktop-${product.id}`">
					{{ product.description }}
				</p>
				<template v-if="showBtnMoreValidate('template1')">
					<button
						class="button-show-more desktop"
						type="button"
						@click="showMore"
					>
						<template v-if="more">Ver más</template>
						<template v-else>Ver menos</template>
					</button>
				</template>
				<div class="related-products-item-price">
					{{ currency }}<span>{{ priceWithoutDecimals }}</span>.{{ priceDecimals }}
				</div>
			</div>
		</div>
		<p class="p-bold text-xs-left mobile" :id="`mobile-${product.id}`">
			{{ product.description }}
		</p>
		<template v-if="showBtnMoreValidate()">
			<button
				class="button-show-more mobile"
				type="button"
				@click="showMore"
			>
				<template v-if="more">Ver más</template>
				<template v-else>Ver menos</template>
			</button>
		</template>
		<div class="related-products-item-actions">
			<div class="quantity-column">
				<quantity-config
					:small="!catalog"
					:quantity="product.quantity"
					:readonly="readonly"
					:theme="theme"
					@add-quantity="$emit('add-quantity', product)"
					@change-value="$emit('change-value', { btnData: $event, product })"
					@sub-quantity="$emit('sub-quantity', product)"
				></quantity-config>
			</div>
			<button
				v-if="!catalog"
				class="add-btn"
				:style="product.isSelected ?
					`background-color: ${theme.secondary}; border-color: ${theme.secondary}; color: ${theme.base};` :
					`border-color: ${theme.secondary}; color: ${theme.secondary};`"
				type="button"
				@click="$emit('add-product', product)"
			>
				<span v-if="product.isSelected">Agregado</span>
				<span v-else>Agregar</span>
			</button>
		</div>
	</div>
</template>

<script>
	import quantityConfig from '@/components/market-place/shared/quantity-config';

	function created() {
		const priceFixed = this.product.price.toFixed(2);
		const priceItems = priceFixed.split('.');
		this.priceWithoutDecimals = priceItems[0];
		this.priceDecimals = priceItems[1];
	}

	function mounted() {
		window.addEventListener('resize', this.showBtnMoreValidate);
	}

	function showBtnMoreValidate() {
		const windowWidth = window.innerWidth;
		const pTag = windowWidth < 936 ? document.getElementById(`mobile-${this.product.id}`) :
			document.getElementById(`desktop-${this.product.id}`);
		const desc = this.product.description || '';
		if (windowWidth) {
			if (desc.length >= 127) {
				this.descLength = desc.length > 127;
				return this.descLength;
			} else if (windowWidth >= 1200) {
				this.descLength = desc.length > 74;
				return this.descLength;
			} else if (windowWidth >= 1024) {
				this.descLength = desc.length > 53;
				return this.descLength;
			} else if (windowWidth >= 936) {
				this.descLength = desc.length > 26;
				return this.descLength;
			} else if (windowWidth >= 850) {
				this.descLength = desc.length > 83;
				return this.descLength;
			} else if (windowWidth >= 768) {
				this.descLength = desc.length > 62;
				return this.descLength;
			} else if (windowWidth >= 600) {
				this.descLength = desc.length > 98;
				return this.descLength;
			} else if (windowWidth >= 508) {
				this.descLength = desc.length > 85;
				return this.descLength;
			} else if (windowWidth >= 460) {
				this.descLength = desc.length > 73;
				return this.descLength;
			} else if (windowWidth >= 425) {
				this.descLength = desc.length > 67;
				return this.descLength;
			} else if (windowWidth >= 375) {
				this.descLength = desc.length > 58;
				return this.descLength;
			}
			if (pTag) {
				pTag.style = 'overflow: hidden; text-overflow: ellipsis; white-space: nowrap';
			}
			this.descLength = desc.length > 48;
			return this.descLength;
		}
		if (pTag) {
			pTag.style = 'overflow: hidden; text-overflow: ellipsis; white-space: nowrap';
		}
		return false;
	}

	function showMore() {
		this.more = !this.more;
		const windowWidth = window.innerWidth;
		const pTag = windowWidth < 936 ? document.getElementById(`mobile-${this.product.id}`) :
			document.getElementById(`desktop-${this.product.id}`);
		pTag.style = this.more ? 'overflow: hidden; text-overflow: ellipsis; white-space: nowrap' :
			'overflow: initial; text-overflow: initial; white-space: initial';
	}

	function watchProduct(value) {
		if (value.id) {
			this.showBtnMoreValidate();
		}
	}

	function data() {
		return {
			descLength: false,
			more: true,
			priceWithoutDecimals: 0,
			priceDecimals: 0,
		};
	}

	export default {
		name: 'related-products-item',
		components: {
			quantityConfig,
		},
		created,
		data,
		methods: {
			showBtnMoreValidate,
			showMore,
		},
		mounted,
		props: {
			catalog: {
				default: false,
				type: Boolean,
			},
			commerceHome: {
				default: false,
				type: Boolean,
			},
			currency: String,
			product: {
				default: () => {},
				type: Object,
			},
			readonly: {
				default: true,
				type: Boolean,
			},
			theme: {
				default: () => {},
				type: Object,
			},
		},
		watch: {
			product: {
				deep: true,
				handler: watchProduct,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.related-products-item {
		border: 1px solid rgba(216, 216, 216, 0.64);
		border-radius: 10px;
		display: inline-block;
		height: 366px;
		margin-right: 12px;
		text-align: center;
		user-select: none;

		&:last-child {
			margin-right: 0px;
		}

		&.commerce-home {
			height: 297px;
			margin-bottom: 25px;
			padding-top: 50px;
			width: 250px;
		}

		&-image {
			height: 132px;
			margin: 18px auto;
			user-select: none;
			position: relative;
			width: 132px;

			img {
				max-height: 100%;
				max-width: 100%;
				user-select: none;
			}
		}

		&-info {
			color: color(newwarning);
			user-select: none;
		}

		&-name {
			font-size: size(medium);
			font-weight: weight(regular);
			line-height: normal;
			margin-bottom: 0px;
			text-transform: capitalize;
			user-select: none;

			&:first-child {
				max-height: 66px;
				overflow: hidden;
				text-overflow: ellipsis;
				width: 80px;

				@media (min-width: 936px) {
					max-height: 44px;
					width: 90%;
				}
			}
		}

		&-brand {
			display: block;
			font-size: size(caption);
			font-weight: weight(black);
			line-height: normal;
			margin: 11px auto 21px;
			text-transform: uppercase;
			user-select: none;
		}

		&-price {
			background-color: color(newbackground);
			font-size: size(caption);
			font-weight: weight(bold);
			height: 37px;
			margin-bottom: 15px;
			margin-left: auto;
			max-width: fit-content;
			max-width: -moz-fit-content;
			min-width: 116px;
			user-select: none;

			span {
				font-size: size(large);
				user-select: none;
			}
		}

		&.catalog-product-item {
			align-items: flex-end;
			border-radius: 16px;
			border-color: #eceded;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			height: auto;
			justify-content: flex-start;
			margin-bottom: 10px;
			max-width: calc(100vw - 30px);
			min-height: 169px;
			padding: 10px 11px;
			width: 100%;

			@media (min-width: 936px) {
				// height: 147px;
				margin-bottom: 17px;
				padding: 14px 23px 11px 44px;
			}

			.catalog-product-container {
				align-items: center;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				justify-content: space-between;
				width: 100%;

				@media (min-width: 936px) {
					max-width: calc(100% - 140px);
				}
			}

			.related-products-item-image {
				align-items: center;
				background-color: #f1efef;
				display: inline-flex;
				flex: 1 1 auto;
				flex-basis: 76px;
				flex-grow: 0;
				height: 76px;
				justify-content: center;
				margin: 0px;
				padding: 0px;
				max-width: 76px;

				@media (min-width: 936px) {
					flex-basis: 122px;
					height: 122px;
					padding: 0px;
					max-width: 122px;
				}
			}

			.related-products-item-price {
				background-color: rgba(#8f8f8f, .15);
				border-radius: 5px;
				height: 46px;
				line-height: 46px;
				margin: 0px;
				min-width: 96px;
				text-align: center;

				@media (min-width: 936px) {
					height: 52px;
					margin-top: 9px;
					min-width: 108px;
				}
			}

			.related-products-item-info {
				display: inline-flex;
				flex: 1 1 auto;
				flex-basis: calc(100% - 76px);
				flex-grow: 0;
				justify-content: space-between;
				max-width: calc(100% - 76px);
				padding-left: 8px;
				text-align: left;

				@media (min-width: 936px) {
					flex-basis: calc(100% - 122px);
					flex-direction: column;
					max-width: calc(100% - 122px);
					padding-left: 45px;
				}
			}

			.related-products-item-actions {
				align-items: center;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				justify-content: space-between;
				width: 100%;

				@media (min-width: 936px) {
					flex-direction: column;
					max-width: fit-content;
					max-width: -moz-fit-content;
				}

				.quantity-column {
					margin-right: 0px;
				}

				.add-btn {
					@media (min-width: 936px) {
						margin-top: 12px;
						width: 100%;
					}
				}
			}
		}
	}

	.commerce-home-container {
		align-items: center;
		display: flex;
	}

	.quantity-column {
		display: inline-block;
		margin-right: 12px;
		vertical-align: middle;
	}

	.add-btn {
		background-color: transparent;
		border-style: solid;
		border-width: 1px;
		border-radius: 5px;
		display: inline-block;
		font-size: size(medium);
		font-weight: weight(bold);
		height: 45px;
		vertical-align: middle;
		width: 107px;
	}
	
	.tooltip {
		align-items: center;
		background-color: rgba(0, 0, 0, .5);
		border-radius: 5px;
		display: flex;
		height: 25px;
		justify-content: center;
		position: absolute;
		right: 2px;
		top: 3px;
		width: 25px;

		&-activator {
			&:hover + .tooltip-text {
				display: flex;
			}
		}

		&-text {
			background-color: #8c8989;
			border-radius: 3px;
			display: none;
			padding: 5px;
			position: absolute;
			top: -35px;
			width: max-content;
			width: -moz-max-content;
			z-index: 1;
		}
	}

	.p-bold {
		font-size: 12px;
		font-weight: weight(bold);
		margin: 0px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;

		&.desktop {
			display: none;

			@media (min-width: 936px) {
				display: initial;
				max-width: 90%;
			}
		}

		&.mobile {
			max-width: 100%;

			@media (min-width: 936px) {
				display: none;
			}
		}
	}

	.button-show-more {
		font-size: 12px;
		font-weight: weight(bold);
		margin-bottom: 5px;
		text-align: left;
		text-decoration: underline;

		&.desktop {
			display: none;

			@media (min-width: 936px) {
				display: initial;
			}
		}

		&.mobile {
			@media (min-width: 936px) {
				display: none;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/product-detail/related-products-item.vue